module.exports = __webpack_public_path__ + "0a2f04366a250c4c997128e30c617de9.png";